import React,{useState} from 'react';
import style from './Navbar.module.css';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { useSpring, animated } from 'react-spring'
import { Link } from 'react-router-dom';

 const Navbar = ({ 
    x, 
    toggle, 
    state,
    about,
    project,
    contact,
    setAbout,
    setProject,
    setProject2,
    setContact,
    setAttendo,
    setAttendoServer,
    setnavCarServer,
    setAboutPageServer,
    setEcommerceServer,
    setProjectServer,
    setDataServer,
    setData,
    setHomePageTimer,
    setProjPageTimer,
    setContactServer
}) => {


    const [images, setImages] = useState({
        logo:
          "https://res.cloudinary.com/oyindacodes/image/upload/v1605096991/logo_nh5kui.svg",
        Fb_Img:
          "https://res.cloudinary.com/oyindacodes/image/upload/v1605096988/facebook_yuritk.svg",
        Ig_Img:
          "https://res.cloudinary.com/oyindacodes/image/upload/v1605096990/instagram_pevhyd.svg",
        be_Img:
          "https://res.cloudinary.com/oyindacodes/image/upload/v1605096988/behance_ukv0je.svg",
        lk_Img:
          "https://res.cloudinary.com/oyindacodes/image/upload/v1605096990/linkedin-3_p4yh62.svg",
        tw_Img:
          "https://res.cloudinary.com/oyindacodes/image/upload/v1605096993/twitter_prkdsa.svg",
        mouseImg:
          "https://res.cloudinary.com/oyindacodes/image/upload/v1605096992/mouse_qwtl1u.svg",
        mcBookImg:
          "https://res.cloudinary.com/oyindacodes/image/upload/v1605021641/Macbook_o9y5ch.svg",
      });


    const setExLinks =()=>{
        setAbout(false);
        setProject(false);
        setProject2(false);
        setContact(false);
        toggle(false);
        setDataServer(false);
        setAboutPageServer(false);
        setContactServer(false);
        setEcommerceServer(false);
        setAttendoServer(false)
        setProjectServer(false);
        setProjPageTimer(false);
    }

   
    const setExLinks1=()=>{
        setAbout(true);
        toggle(false);
        setProject(false);
        setProject2(false);
        setContact(false);
        setnavCarServer(false);
        setEcommerceServer(false);
        setProjectServer(false);
        setAttendoServer(false);
        setDataServer(false);
        setContactServer(false);
        setHomePageTimer(false);
        setProjPageTimer(false);
    }

    const setExtLinks2 = ()=>{
        setProject(true)
        setProject2(false)
        setAbout(false)
        toggle(false)
        setContact(false);
        setAboutPageServer(false);
        setnavCarServer(false);
        setEcommerceServer(false);
        setAttendoServer(false);
        setDataServer(false);
        setContactServer(false);
        setHomePageTimer(false);
        setProjPageTimer(false);
    }

    const setExtLinks3 = ()=>{
        toggle(false)
        setAbout(false)
        setProject(false)
        setProject2(true)
        setContact(false);
        setAboutPageServer(false);
        setProjectServer(false);
        setnavCarServer(false);
        setDataServer(false);
        setAttendoServer(false);
        setContactServer(false);
        setHomePageTimer(false);
        setProjPageTimer(false);
    }

    const setExtLinks4 = ()=>{
        setContact(true);
        toggle(false);
        setAbout(false);
        setProject(false);
        setProject2(false);
        setAboutPageServer(false);
        setProjectServer(false);
        setnavCarServer(false);
        setAttendoServer(false);
        setEcommerceServer(false);
        setDataServer(false);
        setHomePageTimer(false);
        setProjPageTimer(false);
    }

    const setExtLinks5 = ()=>{
        setData(true);
        toggle(false);
        setAbout(false);
        setProject(false);
        setProject2(false);
        setContact(false);
        setAboutPageServer(false);
        setProjectServer(false);
        setnavCarServer(false);
        setAttendoServer(false);
        setEcommerceServer(false); 
        setContactServer(false);
        setHomePageTimer(false);
        setProjPageTimer(false);
    }

    const setExtLink6 =()=>{
        setData(false);
        toggle(false);
        setAbout(false);
        setProject(false);
        setProject2(false);
        setContact(false);
        setAttendo(true);
        setAboutPageServer(false);
        setProjectServer(false);
        setnavCarServer(false);
        setEcommerceServer(false); 
        setContactServer(false);
        setHomePageTimer(false);
    }


    return (
        <animated.div 
            style={{
                opacity: x.interpolate({range: [0,1], output:[0,1] }),
                transform: x
                .interpolate({
                range:[0,0.25,0.35,0.45,0.55,0.65,0.75,1],
                output:[1,0.97,0.9,1.1,0.9,1.1,1.03,1]
                })
                .interpolate(x => `scale(${x})`),
                display: state? x
                .interpolate({
                    range:[0,0.25,0.35,0.45,0.55,0.65,0.75,1],
                    output:[1,0.97,0.9,1.1,0.9,1.1,1.03,1]
                })
                .interpolate(x => `block`):
                x
                .interpolate({
                range:[0,0.25,0.35,0.45,0.55,0.65,0.75,1],
                output:[1,0.97,0.9,1.1,0.9,1.1,1.03,1]
                })
                .interpolate(x => `none`)
            }}
            className={style.container}>
            <IconButton onClick={()=> toggle(false)} className={style.closeBtn} style={{border:'1px solid #fff'}}>
                <CloseIcon  style={{color:'#fff'}} />
            </IconButton>
            <div className={style.linkDiv}>
                <div>
                   
                    <Link style={{textDecoration:'none'}} onClick={()=>setExLinks()} to="/" >
                      Home
                    </Link>
                </div>
                <div>
                    
                    <Link style={{textDecoration:'none'}} onClick={()=>setExLinks1()} to="/about" >About Me</Link>
                </div>
                <div>
                    {/*
                    <Link classNames={style.pageLink} style={{textDecoration:'none'}} onClick={()=>setExtLinks2()} to="/projects" >Dash Me</Link>
                    <Link classNames={style.pageLink} style={{textDecoration:'none'}} onClick={()=>setExtLinks3()} to="/project2" >E-Commerce</Link>
                    <Link classNames={style.pageLink} style={{textDecoration:'none'}} to="/data" onClick={()=>setExtLinks5()} >Data Target</Link>
                    */}
                    
                    <Link style={{textDecoration:'none'}} to="/allProject" onClick={()=>setExtLink6()} >Projects</Link>
                </div>
                <div>
                    <Link style={{textDecoration:'none'}} to="/contact" onClick={()=>setExtLinks4()} >Contact Me</Link>
                </div>
               
            </div>
            <div className={style.links}>
                <a href="https://www.instagram.com/rampiongram/">
                  <img
                    src={images.Ig_Img}
                    className={style.linkImg}
                    alt="Instagram logo"
                  />
                </a>
                <a href="https://twitter.com/rampiondml">
                  <img
                    src={images.tw_Img}
                    className={style.linkImg}
                    alt="twitter logo"
                  />
                </a>
                <a href="https://m.facebook.com/benjaminosewminge?ref=bookmarks">
                  <img
                    src={images.Fb_Img}
                    className={style.linkImg}
                    alt="Facebook logo"
                  />
                </a>
                <a href="https://behance.net/rampiondml">
                  <img
                    src={images.be_Img}
                    className={style.linkImg}
                    alt="Behance logo"
                  />
                </a>
                <a href="https://www.linkedin.com/in/benjamin-osemwengie-8a0b171b7/" target="_blank">
                  <img
                    src={images.lk_Img}
                    className={style.linkImg}
                    alt="Linkedin logo"
                  />
                </a>
              </div>
            <p className={style.bossboon} >© 2020 Osemwengie Benjamin</p>
        </animated.div>
    )
}

export default Navbar
